import React from "react";
import { checkIfInDecember } from "../App";

interface FlipCardProps {
  frontImg: string;
  backImg: string;
  title: string;
  handleClick: () => void;
}

const FlipCard: React.FC<FlipCardProps> = ({
  frontImg,
  backImg,
  title,
  handleClick,
}) => {
  const {weAreInDecember} = checkIfInDecember();
  return (
    <button onClick={handleClick}>
      <div className="flip-card w-full max-w-xs mx-auto h-80">
        <div className="flip-card-inner h-full">
          <div className="flip-card-front h-full">
            <div
              className="relative w-full h-full rounded-lg shadow-md bg-cover bg-center"
              style={{ backgroundImage: `url(${frontImg})` }}
            >

              
              {weAreInDecember && <div className="flex justify-end px-4 py-6">
                <div className="border rounded-full bg-green-500 border-green-500 p-2 flex items-center justify-center shadow-md">
                  <img
                    alt=""
                    src="../../images/hat.png"
                    className="w-10 rounded-full object-contain" 
                  />
                </div>
              </div>}

              {/* Centered title text */}
              <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center">
                <h2 className="text-white px-10 text-base md:text-lg lg:text-3xl xl:text-3xl font-bold">
                  {title}
                </h2>
              </div>
            </div>
          </div>

          <div className="flip-card-back bg-gray-800 rounded-lg flex items-center justify-center h-full">
            <div className="text-center">
              <img src={backImg} alt={title} className="w-44 mx-auto" />
              <h2 className="text-white px-10 text-base md:text-lg lg:text-2xl xl:text-2xl font-bold">
                {title}
              </h2>
              <button
                onClick={handleClick}
                className="mt-4 text-lg text-[#047E35] py-2 px-4 rounded hover:bg-[#047E35] hover:text-white"
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
};

export default FlipCard;
